<template>
  <div class="AppHeader">
    <div id="topheaderLeft">
      <dv-decoration-8 style="height: 50px" />
    </div>

    <div id="topheaderCenter">
      <dv-decoration-5 style="height: 40px"> </dv-decoration-5>
    </div>

    <div id="topheaderRight">
      <dv-decoration-8 :reverse="true" style="height: 50px" />
    </div>

    <div id="center-title">
      <span>      智慧物流数字孪生监控系统 </span>
    </div>
  </div>
</template>

<script>
export default {
  name: "AppHeader",
};
</script>

<style scoped>
.AppHeader {
  width: 100%;
 
}

#topheaderCenter {
  width: 40%;
  float: left;
  margin-top: 30px;
  text-align: center;
  position: relative;
}

#topheaderLeft {
  width: 30%;
  float: left;
}

#topheaderRight {
  width: 30%;
  float: right;
}

#center-title {
  position: absolute;
  font-size: 30px;
  font-weight: bold;
  left: 50%;
  top: 10px;
  transform: translateX(-50%);
  color: white;
}
</style>